import React, { Children } from 'react';
import { Link } from 'react-router-dom';
export function PrivacyPolicyPage() {
  return <main className="pt-32 pb-24 bg-brand-black min-h-screen" data-id="element-373">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-374">
        <div className="mb-12 border-b border-brand-gold/20 pb-8" data-id="element-375">
          <h1 className="font-heading text-4xl md:text-5xl text-brand-white mb-4" data-id="element-376">
            Privacy Policy
          </h1>
          <p className="text-brand-gold font-medium" data-id="element-377">
            Effective date: January 1, 2026
          </p>
        </div>

        <div className="prose prose-invert prose-brand max-w-none text-brand-champagne-light/80 space-y-8" data-id="element-378">
          <p className="text-lg leading-relaxed" data-id="element-379">
            Deluxe MedSpa Beauty (“we,” “us,” or “our”) respects your privacy
            and is committed to protecting the personal information you provide
            through our website, appointment request forms, and communications
            with us. This Privacy Policy explains how we collect, use, store,
            and protect your information.
          </p>

          <section data-id="element-380">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-381">
              1. Information We Collect
            </h2>
            <p className="mb-4" data-id="element-382">
              We may collect the following types of personal information when
              you interact with our website or services:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-383">
              <li data-id="element-384">Name</li>
              <li data-id="element-385">Phone number</li>
              <li data-id="element-386">Email address</li>
              <li data-id="element-387">Appointment request details</li>
              <li data-id="element-388">Preferred services</li>
              <li data-id="element-389">Communication preferences</li>
              <li data-id="element-390">Website usage information</li>
            </ul>
          </section>

          <section data-id="element-391">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-392">
              2. How We Use Information
            </h2>
            <p className="mb-4" data-id="element-393">
              We use the collected information for the following purposes:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-394">
              <li data-id="element-395">Respond to inquiries</li>
              <li data-id="element-396">Schedule and manage appointments</li>
              <li data-id="element-397">Send appointment confirmations and reminders</li>
              <li data-id="element-398">Send service-related updates</li>
              <li data-id="element-399">
                Send promotional messages only where consent has been provided
              </li>
              <li data-id="element-400">Improve our website and client experience</li>
            </ul>
          </section>

          <section data-id="element-401">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-402">
              3. SMS Communications
            </h2>
            <div className="bg-brand-charcoal border-l-4 border-brand-gold p-6 rounded-r-sm" data-id="element-403">
              <p className="text-brand-white leading-relaxed" data-id="element-404">
                If you opt in to receive SMS messages from Deluxe MedSpa Beauty,
                you may receive text messages related to your inquiry,
                appointment scheduling, appointment confirmations, reminders,
                service updates, and, where consent has been provided,
                promotional offers. Message frequency may vary. Message and data
                rates may apply. Reply STOP to opt out at any time. Reply HELP
                for assistance.
              </p>
            </div>
          </section>

          <section data-id="element-405">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-406">
              4. Sharing of Information
            </h2>
            <p className="font-medium text-brand-white mb-4" data-id="element-407">
              Mobile opt-in data and consent information will not be shared,
              sold, or disclosed to third parties for marketing or promotional
              purposes.
            </p>
            <p data-id="element-408">
              We may share information with trusted service providers only as
              necessary to operate our website, scheduling systems, or business
              communications, subject to confidentiality and data protection
              obligations.
            </p>
          </section>

          <section data-id="element-409">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-410">
              5. Data Security
            </h2>
            <p data-id="element-411">
              We implement reasonable security measures to protect your personal
              information from unauthorized access, alteration, disclosure, or
              destruction. However, no internet transmission is entirely secure,
              and we cannot guarantee absolute security.
            </p>
          </section>

          <section data-id="element-412">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-413">
              6. Cookies and Analytics
            </h2>
            <p data-id="element-414">
              Our website may use cookies and similar tracking technologies to
              enhance user experience and analyze website traffic. You can
              adjust your browser settings to refuse cookies, though some
              features of the site may not function properly.
            </p>
          </section>

          <section data-id="element-415">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-416">
              7. Your Choices
            </h2>
            <p data-id="element-417">
              You have the right to review, update, or request deletion of your
              personal information. You may opt out of promotional
              communications at any time by following the unsubscribe
              instructions provided in the message or by contacting us directly.
            </p>
          </section>

          <section data-id="element-418">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-419">
              8. Children's Privacy
            </h2>
            <p data-id="element-420">
              Our services are not directed to individuals under the age of 18.
              We do not knowingly collect personal information from children.
            </p>
          </section>

          <section data-id="element-421">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-422">
              9. Updates to This Policy
            </h2>
            <p data-id="element-423">
              We may update this Privacy Policy periodically to reflect changes
              in our practices or legal requirements. The updated policy will be
              posted on this page with a revised effective date.
            </p>
          </section>

          <section data-id="element-424">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-425">
              10. Contact Information
            </h2>
            <p className="mb-4" data-id="element-426">
              If you have any questions about this Privacy Policy, please
              contact us at:
            </p>
            <div className="bg-brand-charcoal/50 p-6 rounded-sm border border-brand-charcoal inline-block" data-id="element-427">
              <address className="not-italic text-brand-white" data-id="element-428">
                <strong className="text-brand-gold block mb-2 font-heading text-xl" data-id="element-429">
                  Deluxe MedSpa Beauty
                </strong>
                30 SW 1st St #1001
                <br data-id="element-430" />
                Miami, FL 33132
                <br data-id="element-431" />
                Phone: 786-901-0611
              </address>
            </div>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-brand-gold/20 flex flex-wrap gap-6" data-id="element-432">
          <Link to="/terms-conditions" className="text-brand-gold hover:text-brand-gold-light transition-colors" data-id="element-433">
            &larr; Read Terms & Conditions
          </Link>
          <Link to="/sms-terms" className="text-brand-gold hover:text-brand-gold-light transition-colors" data-id="element-434">
            Read SMS Terms &rarr;
          </Link>
        </div>
      </div>
    </main>;
}